import { Button } from "@mui/material";
import React from "react";
import "./moreactionmenu.scss";
import editIcon from "../../assets/images/edit.svg";
import { useNavigateKeepParams } from "../../utlis/useNavigateKeepParams";
import { useSection } from "../../i18n/useSection";

const MoreActionMenu = ({ userInfo, seniorId }) => {
  const { edit_info } = useSection("testModule");
  const navigateKeepParams = useNavigateKeepParams();
  const uuid = seniorId || userInfo?.id;

  const editTestPersonHandler = () => {
    if (!uuid) return;
    sessionStorage.removeItem("userList");
    navigateKeepParams(`/edit-test-person?seniorUuid=${uuid}`);
  };

  return (
    <Button
      className="edit-person-button"
      aria-label={edit_info}
      title={edit_info}
      onClick={editTestPersonHandler}
      disabled={!uuid}
    >
      <img src={editIcon} alt="" aria-hidden="true" />
    </Button>
  );
};

export default MoreActionMenu;
